var m = require('mithril');
var animations = require('../../libs/animations');
var session = require('../../auth/models/session');
var edit = require('../../layout/components/edit');
var columnForm = require('../../data/components/columnModal');
var modalForm = require('../../layout/components/modalForm');
var pointWrite = require('../../data/components/writeModal');
var multiPointWriteModal = require('../../data/components/multiPointWriteModal');
var pointTrendModal = require('../../data/components/pointTrendModal');
var pointOverride = modalForm(require('../../data/models/override'));
var Point = require('../../data/models/point');
var isAggregatePoint = require('../../data/isAggregatePoint');
var pointSubscriber = require('../../components/pointSubscriberClass');
var elementSmallChart = require('../../data/components/elementSmallChart');
var canWriteColumn = require('../../data/canWriteColumn');

var chartwithpointText = {
  oninit : function (vnode) {
    this.column = vnode.attrs.columnRecord;
    this.element = vnode.attrs.element;
    this.parentReinitialize = vnode.attrs.parentReinitialize;
  },
  oncreate: function () {
    this.pointSubscriberObj = new pointSubscriber();
    this.pointSubscriberObj.subscribe(this);
  },
  onremove: function () {
    this.pointSubscriberObj.unsubscribe(this);
  },
  view: function (vnode) {
    var ctrl = this;
    var parentRid = vnode.attrs.parentRid;
    var clickFunction = function (e) {
      e.preventDefault();
      
      if (edit.vm.editing()) {
        return columnForm.editDialogue(ctrl.column, {submitCallback: ctrl.parentReinitialize});
      }

      if (!canWriteColumn(ctrl.column)) {
        return pointTrendModal.open(ctrl.column);
      }
      if (isAggregatePoint(ctrl.column)) {
        return pointTrendModal.open(ctrl.column);
      }

      if (Number(ctrl.column.in.overrides) &&  ctrl.column.in.out_OverrideMode && ctrl.column.in.out_OverrideValue) {
          return pointOverride.editDialogue(ctrl.column, parentRid);
      }
      if (ctrl.column.in.writeGroup) {
        multiPointWriteModal.editDialogue(ctrl.column, parentRid);
      } else if (Number(ctrl.column.in.writable)) {
        pointWrite.editDialogue(ctrl.column, parentRid);
      } else {
        pointTrendModal.open(ctrl.column);
      }
    };

    var isExpired = Date.now() - ctrl.column.in.time > 60000;
    var displayValue = Point.readValue(isExpired ? undefined : ctrl.column.in) || '';
    var displayColor = (Number(ctrl.column.in.overrideActive) ? '.yellow' :  (ctrl.column.in.alarmStatus == 'Alarm Tripped' ? '.red' : '.blue'))
    var valueSpan;

    if (Number(session.user().typewriterEffect)) {
      valueSpan = [
        m('span.ma0' + displayColor, {
          typewriterString: displayValue, 
          onupdate: animations.typer
        }, displayValue),
      ];
    } else {
      valueSpan = m('span.ma0' + displayColor, displayValue);
    }

    return m('div.flex.justify-between.bb.bw1',[
      m('label.f1.mt2.truncate-ns.blue', {
        style: {display: edit.vm.editing() ? '': 'none'},
        onclick: columnForm.editDialogue.bind(columnForm, ctrl.column, { delete: true, submitCallback: ctrl.parentReinitialize, dashboardCallback: ctrl.parentReinitialize, columnNameRequired: true })
      }, ctrl.column.name),
      m(elementSmallChart,  {element:ctrl.element}),
      m('div',[
          m('a.ph1.f4.pointer.flex.justify-start.tl.mt2', {
              onclick: clickFunction, 
              href: '#',
              'aria-haspopup': 'dialog',
              title: edit.vm.editing() ? 'Edit point binding' : 'View trend chart',
              'data-point-rid': ctrl.column.in['@rid']
          }, [
              m('span.moon-gray', { style: {
              'text-decoration': isExpired ? 'line-through' : '',
              minWidth: displayValue.length + 'ch',
              fontSize: '26px'
              }}, valueSpan)
        ])
      ])
    ])
  }
};

module.exports = chartwithpointText;
